import {
  SCRAPER_REQUEST_PARAM,
  ScrapingParamInputFieldConfig,
} from '@decodo/utils';
import React from 'react';

import { UseFormReturn } from '@/hooks/useForm';

import { useScraperTranslations } from '@/blocks/Scraper/scraperTranslations';
import Checkbox, { CheckboxProps } from '@/components/atoms/Checkbox';

type FormCheckboxProps = {
  param: ScrapingParamInputFieldConfig;
  form: UseFormReturn<Record<string, string | boolean>>;
  isDisabled?: boolean;
};

const getCheckboxProps = (
  param: ScrapingParamInputFieldConfig,
  form: UseFormReturn<Record<string, string | boolean>>
): Pick<CheckboxProps, 'onChange' | 'checked'> => {
  if (param.key === SCRAPER_REQUEST_PARAM.HEADLESS) {
    return {
      onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
        form.setFieldValue(param.key, !!e.target.checked ? 'html' : '');
      },

      checked: form.values[param.key] === 'html',
    };
  }

  return {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      form.setFormValues({
        ...form.values,
        [param.key]: !!e.target.checked,
        // setting parse to false is needed, otherwise the "markdown" is ignored by BE.
        parse: !e.target.checked,
      });
    },
    checked: !!form.values[param.key],
  };
};
const FormCheckbox = ({ param, form, isDisabled }: FormCheckboxProps) => {
  const checkboxProps = getCheckboxProps(param, form);
  const { getTranslation } = useScraperTranslations();

  return (
    <Checkbox
      classNames={{
        root: !checkboxProps.checked ? 'dark:bg-gray-dark-900' : undefined,
        label: 'text-body-l',
      }}
      tooltip={getTranslation(param.description?.id ?? '')}
      value={param.key}
      label={getTranslation(param.header.id ?? '')}
      isDisabled={isDisabled}
      {...checkboxProps}
    />
  );
};

export default FormCheckbox;
